import React, { useEffect, useState } from "react";
import "./Support.scss";

import { IoSearch } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";

import CustomButton from "../../../components/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { addSupportTicket, fetchSupportTickets } from "../../../api/support";
import { useForm } from "react-hook-form";
import InputField from "../../../components/InputField/InputField";
import InputSelect from "../../../components/InputSelect/InputSelect";
import { toast } from "react-toastify";
import { updateOpenSubscriptionAd } from "../../../redux/features/subscription-slice";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import SupportDetail from "./SupportDetail/SupportDetail";
import { IoIosArrowBack } from "react-icons/io";
import { updateOpenSupport } from "../../../redux/features/user-slice";
import { useViewPortDetector } from "../../../helpers/viewPortDetector";

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const Support = ({ isModel }) => {
  const { currentViewPort, isReady } = useViewPortDetector();
  const dispatch = useDispatch();
  const [keyword, setKeyword] = useState("");
  const {
    name,
    id: user_id,
    image: user_image,
    token,
  } = useSelector((state) => state.userReducer.value);

  const navigate = useNavigate();

  const [supportTickets, setSupportTickets] = useState([]);
  const [openCreateForm, setOpenCreateForm] = useState(false);
  const [selectedSupport, setSelectedSupport] = useState(null);

  useEffect(() => {
    loadSupportTickets();
  }, [user_id, keyword]);

  const loadSupportTickets = () => {
    setSelectedSupport();
    fetchSupportTickets(keyword)
      .then((res) => {
        if (res.data?.length > 0) {
          setSupportTickets(res.data);
        } else {
          setSupportTickets([]);
        }
      })
      .catch((err) => {});
  };

  const handleCloseSupportModel = () => {
    dispatch(updateOpenSupport({ open_support: false }));
  };

  useEffect(() => {
    if (isReady && !isModel && currentViewPort === "desktop") {
      navigate(`${ROUTES.help.path}?query=support`);
    }
  }, [isModel, isReady, currentViewPort]);

  return (
    <>
      {isModel && (
        <div className="support-model-navbar">
          <div
            className="back"
            onClick={() => {
              if (selectedSupport) {
                setSelectedSupport(null);
              } else {
                handleCloseSupportModel();
              }
            }}
          >
            <IoIosArrowBack />
          </div>
          <p>
            {selectedSupport ? `#${selectedSupport?.id}` : "Support Tickets"}
          </p>
        </div>
      )}
      {isModel && selectedSupport ? (
        <SupportDetail selected={selectedSupport} reload={loadSupportTickets} />
      ) : (
        <div className={`support-page ${isModel ? "is-model" : ""}`}>
          <div className="container-wrapper support-container">
            {/* <div className="support-user">
              <div className="left">
                <span>Welcome Back!</span>
                <p>{name || "N/A"}</p>
              </div>
              <div className="image">
                <img
                  src={
                    user_image
                      ? `${IMAGE_URL}${user_image}`
                      : "/images/profile.svg"
                  }
                  alt="" aria-label={`${name}'s Profile Image`}
                />
              </div>
            </div> */}

            <form
              onSubmit={(e) => {
                e.preventDefault();
                setKeyword(e.target.keyword.value);
              }}
              className="support-search"
            >
              <div className="inputs">
                <input type="text" name="keyword" placeholder="Search" />
                <button type="submit">
                  <IoSearch />
                </button>
              </div>
            </form>

            <div
              className={`support-list ${
                supportTickets?.length > 0 ? "items" : ""
              }`}
            >
              {supportTickets?.length > 0 ? (
                supportTickets.map((item, i) => {
                  return (
                    <div
                      className="item"
                      key={i}
                      onClick={() => {
                        if (isModel) {
                          setSelectedSupport(item);
                        } else {
                          localStorage.setItem("socket-token", token);
                          navigate(ROUTES.supportDetails.path, {
                            state: { supportDetails: item },
                          });
                        }
                      }}
                    >
                      <svg
                        width="78"
                        height="108"
                        viewBox="0 0 78 108"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4 2.96484C10.3329 14.5642 36.3893 48.4777 68.2016 39.2193C100.014 29.961 101.418 -2.66733 86.9418 -7.09473C50.6197 -8.95637 20.8139 31.0861 59.6633 76.6657C98.5126 122.245 130.357 99.7367 141.423 82.7848"
                          stroke="#616161"
                          strokeOpacity="0.15"
                          strokeWidth="7"
                        />
                      </svg>
                      <p className="title">#{item?.ticket_id}</p>
                      <p className="desc">{item?.title}</p>
                      <div>
                        <p>
                          {item?.created_at
                            ? format(item?.created_at, "dd/MM/yyyy")
                            : "dd/MM/yyyy"}
                        </p>

                        <span
                          className={
                            item?.status === "Pending"
                              ? "yellow"
                              : item?.status === "In Progress"
                              ? "dark"
                              : item?.status === "Completed"
                              ? "green"
                              : "red"
                          }
                        >
                          {item?.status || "Status"}
                        </span>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className="empty">No tickets found.</p>
              )}
            </div>
          </div>
          <div className="floating-button">
            <CustomButton
              name={`New Support Ticket`}
              type={"button"}
              color={"white"}
              bigButton={true}
              handleSubmit={() => {
                setOpenCreateForm(true);
              }}
              disabled={false}
            />
          </div>

          <CreateSupportTicket
            open={openCreateForm}
            setOpen={setOpenCreateForm}
            supportTickets={supportTickets}
            setSupportTickets={setSupportTickets}
          />

          {openCreateForm && (
            <div
              className="blur-back"
              onClick={() => {
                setOpenCreateForm(false);
              }}
            ></div>
          )}
        </div>
      )}
    </>
  );
};

export default Support;

const CreateSupportTicket = ({
  open,
  setOpen,
  supportTickets,
  setSupportTickets,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const { id: organization_id } = useSelector(
    (state) => state.organizationReducer.value
  );
  const dispatch = useDispatch();

  const supportTopics = [
    {
      label: "Technical Support",
      value: "Technical Support",
    },
    {
      label: "General Support",
      value: "General Support",
    },
    {
      label: "Inquiry",
      value: "Inquiry",
    },
    {
      label: "Others",
      value: "Others",
    },
  ];

  const [image, setImage] = useState({
    src: null,
    file: null,
  });

  const [selectedTopic, setSelectedTopic] = useState({
    label: "",
    value: "",
  });

  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    reset({
      title: "",
      topic: "",
      query_desc: "",
    });
    setImage({
      src: null,
      file: null,
    });
    setSelectedTopic({
      label: "",
      value: "",
    });
  }, [open]);

  const handleAddNewSupportTicket = (data) => {
    setSubmitting(true);

    const supportTicketData = new FormData();
    supportTicketData.append("title", data?.title);
    supportTicketData.append("topic", selectedTopic?.value);
    supportTicketData.append("query_desc", data?.query_desc);
    supportTicketData.append("organization_id", organization_id);
    if (image.file) {
      supportTicketData.append("image", image.file);
    }

    addSupportTicket(supportTicketData)
      .then((res) => {
        if (res.data?.id) {
          let temp_tickets = [res.data, ...supportTickets];
          setSupportTickets(temp_tickets);
        }
        setOpen(false);
        toast.dismiss(); toast.success("New ticket issued.");
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
        } else {
          toast.dismiss(); toast.error("Error while creating new user.");
        }
        if (err?.response?.data?.upgrade) {
          dispatch(updateOpenSubscriptionAd({ openAd: true }));
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleImageChange = (e) => {
    let file = e.target.files[0];
    if (file) {
      let url = URL.createObjectURL(file);
      setImage({
        src: url,
        file: file,
      });
    } else {
      setImage({ src: null, file: null });
    }
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;

  return (
    <form
      onSubmit={handleSubmit(handleAddNewSupportTicket)}
      className={`create-support-ticket ${isVisible ? "active" : ""}`}
    >
      <h1 className="heading">New Support Ticket</h1>

      <div className="form-content">
        <InputField
          name={"title"}
          type={"text"}
          label={"Title"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
        />

        <InputSelect
          options={supportTopics}
          value={selectedTopic}
          register={register}
          required={true}
          name="topic"
          handleChange={(opt) => {
            setSelectedTopic(opt);
          }}
          reset={reset}
          label={"Issue Topic"}
          inputErrors={errors}
        />

        <InputField
          name={"query_desc"}
          type={"text"}
          label={"Description"}
          required={false}
          textArea={true}
          register={register}
          inputErrors={errors}
          watch={watch}
        />

        <div className="file-input">
          <input
            type="file"
            accept="image/*,application/pdf"
            onChange={handleImageChange}
          />
          <FiDownload />
          <p>{image?.file ? "File selected" : "Choose your file"}</p>
        </div>
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpen(false);
          }}
          disabled={submitting}
        />

        <CustomButton
          name={"Confirm"}
          color={"primary"}
          type={"submit"}
          handleSubmit={() => {}}
          disabled={submitting}
          loader={submitting}
        />
      </div>
    </form>
  );
};
